
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/termsofservices",
      function () {
        return require("private-next-pages/termsofservices/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/termsofservices"])
      });
    }
  